// extracted by mini-css-extract-plugin
export default {"iata":"alaCm","additionalInfo":"_2R-E0","transparent":"_67krm","AirportIcon":"_1QHeW","RailwaysIcon":"_9LHyb","HotelsIcon":"oCI9l","MapPointIcon":"WerQ9","skeleton-progress":"eSWvb"};